declare global {
  interface Window {
    gtag?: GtagFunction;
  }
}

// Type for the gtag function
type GtagFunction = {
  (command: "config", targetId: string, config?: Record<string, unknown>): void;
  (command: "event", eventName: string, params?: GtagEventParams): void;
  (command: "js", config: Date): void;
};

// Type for event parameters (Google Ads conversion)
export interface GtagEventParams {
  send_to: string;
  [key: string]: unknown;
}

export function trackGtagConversion(): void {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "sign_up", {
      send_to: "AW-17137501800/8VhcCNqd2NAaEOiM5us_",
    });
  } else {
    console.warn("gtag is not available");
  }
}
